const STAGES = [
  { number: '01', name: 'Script & Previz', description: 'Creative development, AI storyboarding & shot design.', tools: 'Concept · Animatics' },
  { number: '02', name: 'Shoot or Prompt', description: 'Live-action plate capture (Hybrid) or 100% AI scene synthesis.', tools: 'ARRI / RED · AI Generation' },
  { number: '03', name: 'MX AI Engine', description: 'Multi-keyframe world building, character consistency & relighting.', tools: 'Seedance 2.0 · Beeble SwitchX' },
  { number: '04', name: 'VFX Compositing', description: 'Node-based rotoscoping, foreground integration & 4K upscaling.', tools: 'ComfyUI · RealESRGAN · Nuke' },
  { number: '05', name: 'Editorial & Grade', description: 'Human-supervised cut, sound design & Rec.709 color finishing.', tools: 'DaVinci Resolve · Premiere Pro' },
  { number: '06', name: 'Master Delivery', description: 'Broadcast ProRes 4444, theatrical DCP & 9:16 social masters.', tools: '2K/4K ProRes · 100% Client IP' },
];

export default function PipelineSection() {
  return (
    <section
      id="pipeline"
      className="bg-[#050505] py-20 sm:py-28 border-t border-white/[0.08] w-full"
    >
      <div className="w-full px-5 sm:px-10 lg:px-16 xl:px-24">
        <div className="max-w-2xl pb-10 border-b border-white/[0.08]">
          <p className="text-[11px] font-mono uppercase tracking-[0.14em] text-[#E50914] mb-2">
            ● Production Infrastructure
          </p>
          <h2 className="text-white font-normal tracking-[-0.03em] leading-[1.05] text-[clamp(1.85rem,3.4vw,3.25rem)]">
            The MotionX Pipeline
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-6 pt-10">
          {STAGES.map((s) => (
            <div key={s.number} className="border-t border-white/15 pt-4 flex flex-col justify-between">
              <div>
                <span className="text-[11px] font-mono text-[#E50914] font-semibold block mb-3">
                  {s.number}
                </span>
                <h3 className="text-[17px] font-medium tracking-[-0.02em] text-white mb-2">
                  {s.name}
                </h3>
                <p className="text-[13px] text-[#767d88] leading-relaxed">
                  {s.description}
                </p>
              </div>
              <p className="text-[11px] font-mono text-white/45 mt-4">{s.tools}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
